/**
 * Resumen de ítems del DO en ventana independiente (Diego 2026-10-05): ruta propia
 * /resumen-items/{DO} con la sesión persistida, igual que el informe de inspección.
 * Solo lectura. Sin sesión vuelve al inicio.
 * @author Diego Serrano <diego.serrano@repremundo.com.co>
 * @since 2026-10-05
 */
import React from "react";
import { useSelector } from "react-redux";
import { Navigate, useParams } from "react-router-dom";
import Resuitem from "../components/Modimpxx/Documexx/Itemdoxx/Resuitem";
import { getisLoggedIn } from "../libs/redux/slices/authSlice/authSlice";

const ResumenItemsPage = () => {
  const { DOCNROXX } = useParams();
  const isLoggedIn = useSelector(getisLoggedIn);
  if (!isLoggedIn) {
    return <Navigate to="/" />;
  }
  return (
    <div style={{ minHeight: "100vh", background: "#F5F5F5" }}>
      <Resuitem DOCNROXX={DOCNROXX} onVolver={() => window.close()} />
    </div>
  );
};

export default ResumenItemsPage;
